import React from "react";

const AuthDispatchContext = React.createContext();

export default AuthDispatchContext;